import Vue from 'vue'
import { mapState } from 'vuex'
import { isMobile } from '@/lib/helpers/index.ts'

import BackButton from '@/components/back-button/back-button.vue'
import VButton from '@/components/button/basic-button.vue'
import UnitPanel from '@/components/unit-panel/unit-panel.vue'
import Exam from './components/exam/exam.vue'
import Exercise from './components/exercise/exercise.vue'
import ProgressLinear from '@/components/progress-linear/progress-linear.vue'
import SwipeNavButton from '@/components/swipe-nav-button/swipe-nav-button.vue'

import CheckPage from './components/CheckPage.vue'

import { getContent } from '@/api/content'
import { getUnit } from '@/api/unit'
import { getImpl, setPrivateResult } from '@/api/unit_impl'

interface Data {
  showAnswer: boolean
  targetQuestion: api.unitImpl.Question | undefined
  content: api.content.Content | undefined
  unit: api.unit.GetUnitResponseData | undefined
  implResult: api.unitImpl.UnitImplResult | undefined
  isPrivate: boolean
  correctAnswerRate: any
  isMobile: boolean
  showSecondSwipeBtn: boolean
}

export default Vue.extend({
  name: 'Show',

  components: {
    BackButton,
    VButton,
    UnitPanel,
    Exam,
    Exercise,
    CheckPage,
    ProgressLinear,
    SwipeNavButton
  },

  data(): Data {
    return {
      showAnswer: false,
      targetQuestion: undefined,
      content: undefined,
      unit: undefined,
      implResult: undefined,
      isPrivate: false,
      correctAnswerRate: undefined,
      isMobile: isMobile(),
      showSecondSwipeBtn: false
    }
  },

  created() {
    this.fetchData()
  },
  computed: {
    ...mapState(['loading', 'user']),
    fromExam(): boolean {
      return !!this.$route.query.finish
    },
    questions(): api.unitImpl.Question[] {
      return this.implResult?.questions || []
    },
    rate(): number {
      const impl = this.implResult as api.unitImpl.UnitImplResult

      if (!impl || !impl.result) {
        return 0
      }

      return Math.round(impl.result.correct_rate * 100)
    },
    categorizedRates(): api.unitImpl.CategoryRate[] {
      const impl = this.implResult as api.unitImpl.UnitImplResult

      if (!impl || !impl.result) {
        return []
      }

      return impl.result.categorized_rates
    },
    progress(this: any): number {
      return (
        (100 / this.implResult.questions.length) * this.targetQuestion.impl.seq
      )
    },
    previousRate(): number | undefined {
      const impl = this.implResult as api.unitImpl.UnitImplResult

      if (!impl || !impl.previous_result) {
        return
      }

      return Math.round(impl.previous_result.correct_rate * 100)
    },
    swiperOption(this: any): any {
      return {
        swipeHandler: 'empty',
        spaceBetween: 0,
        initialSlide: this.targetQuestion.impl.seq - 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    },
    resultComponent(this: any): any {
      if (!this.implResult) {
        return
      }

      if (this.implResult.is_normal_exam) {
        return Exam
      } else {
        return Exercise
      }
    }
  },

  methods: {
    async fetchData() {
      this.$store.dispatch('loading')

      const unitRes = await getUnit(
        +this.$route.params.id,
        +this.$route.query.content
      )
      this.unit = unitRes.data

      const contentRes = await getContent(+this.$route.query.content)
      this.content = contentRes.data

      this.getImplResult(this.unit.id)

      this.$store.dispatch('loading', false)
    },

    handleCheck(q: api.unitImpl.Question) {
      if (this.unit!.grade !== 0) {
        if (!this.content!.current_contract && this.user.role !== 'ADMIN') {
          return
        }
      }
      this.showAnswer = true
      this.targetQuestion = q
    },

    handleExit() {
      const content = this.content as api.content.Content
      this.$router.push({ path: `/contents/${content.id}` })
    },

    handleClickFinish() {
      if (this.unit) {
        this.$router.push({
          path: `/units/${this.unit.id}/results?content=${this.$route.query.content}`
        })
      }
    },

    async setPrivate(check: boolean) {
      const { message } = await setPrivateResult(
        this.unit?.id,
        this.implResult?.id,
        check
      )
      Vue.notify({
        text: message,
        type: 'success'
      })
    },

    handleSlidePrev(this: any) {
      this.targetQuestion.impl.seq = this.targetQuestion.impl.seq - 1
      window.scrollTo(0, 0)
    },

    handleSlideNext(this: any) {
      this.targetQuestion.impl.seq = this.targetQuestion.impl.seq + 1
      window.scrollTo(0, 0)
    },

    async getImplResult(unitId: any) {
      await getImpl(unitId, +this.$route.params.implId)
        .then(res => {
          this.implResult = res.data
          this.correctAnswerRate = res.data.estimated_correct_answer_rate
          this.isPrivate = res.data.is_private
        })
        .catch((err: any) => {
          if (err.response && err.response.status === 404) {
            this.$router.push({ path: '/dashboard' })
          }
        })
    },

    closeQuestionDetail(this: any) {
      this.showAnswer = false
      this.getImplResult(this.unit.id)
    },

    updateShowSecondSwipeBtn(show: boolean) {
      this.showSecondSwipeBtn = show
    }
  }
})
